// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectDesktopSharingScreenPopup__container-e5e609 {
  flex: 1;
  overflow: auto;
  padding: 16px 24px;
}

.SelectDesktopSharingScreenPopup__grid-f75bf4 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 12px;
  row-gap: 12px;
}

.SelectDesktopSharingScreenPopup__item-a3d675 {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px;
}

.SelectDesktopSharingScreenPopup__item-a3d675:hover,
.SelectDesktopSharingScreenPopup__item-a3d675:focus-visible {
  background-color: var(--base-30);
}

.SelectDesktopSharingScreenPopup__imageContainer-c72365 {
  width: 160px;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}

.SelectDesktopSharingScreenPopup__image-b06881 {
  max-width: 100%;
  max-height: 100%;
}

.SelectDesktopSharingScreenPopup__title-e39967 {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 160px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/popups/SelectDesktopSharingScreenPopup/SelectDesktopSharingScreenPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  overflow: auto;\n  padding: 16px 24px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 12px;\n  row-gap: 12px;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 4px;\n  padding: 8px;\n}\n\n.item:hover,\n.item:focus-visible {\n  background-color: var(--base-30);\n}\n\n.imageContainer {\n  width: 160px;\n  height: 110px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.image {\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  width: 160px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SelectDesktopSharingScreenPopup__container-e5e609`,
	"grid": `SelectDesktopSharingScreenPopup__grid-f75bf4`,
	"item": `SelectDesktopSharingScreenPopup__item-a3d675`,
	"imageContainer": `SelectDesktopSharingScreenPopup__imageContainer-c72365`,
	"image": `SelectDesktopSharingScreenPopup__image-b06881`,
	"title": `SelectDesktopSharingScreenPopup__title-e39967`
};
module.exports = ___CSS_LOADER_EXPORT___;
